import { Link, NavLink, Outlet } from "react-router-dom";
import { ThemeToggle } from "./ThemeToggle";

const navLinkClass = ({ isActive }: { isActive: boolean }) =>
  `transition-colors ${
    isActive
      ? "text-[var(--color-kj-text)]"
      : "text-[var(--color-kj-text-light)] hover:text-[var(--color-kj-text)]"
  }`;

export const PublicLayout = () => {
  return (
    <div className="min-h-screen flex flex-col theme-transition">
      <header className="pt-16 pb-12 px-8 text-center border-b border-[var(--color-kj-border)]">
        <Link to="/" className="inline-block">
          <h1 className="font-display text-4xl md:text-5xl text-[var(--color-kj-text)]">
            Kinsey Jones
          </h1>
        </Link>
        <p className="mt-2 text-sm text-[var(--color-kj-text-light)]">
          made in Kentucky, with love
        </p>
      </header>

      <nav className="flex justify-center items-center gap-10 px-8 py-5 border-b border-[var(--color-kj-border)] text-xs uppercase-track">
        <NavLink to="/" end className={navLinkClass}>
          Work
        </NavLink>
        <NavLink to="/about" className={navLinkClass}>
          About
        </NavLink>
        <NavLink to="/contact" className={navLinkClass}>
          Contact
        </NavLink>
      </nav>

      <main className="flex-1">
        <Outlet />
      </main>

      <footer className="text-center px-8 py-12 text-xs text-[var(--color-kj-text-light)] uppercase-track">
        <div className="flex justify-center mb-3">
          <ThemeToggle />
        </div>
        <p>&copy; {new Date().getFullYear()} Kinsey Jones</p>
        <p className="mt-3">
          <Link
            to="/admin/login"
            className="text-[10px] tracking-[0.1em] text-[var(--color-kj-text-light)]/70 hover:text-[var(--color-kj-text)] transition-colors"
          >
            Admin
          </Link>
        </p>
      </footer>
    </div>
  );
};
